export default __webpack_public_path__ + "media/images/dashboard_icons/menus-3f0a43c12b9addf48d9996f6be7307b4.svg";